import React from 'react';
import IZebraDetail from './IZebraDetail';
import * as style from './ZebraDetailStyle.module.scss'

const ZebraDetail: React.FunctionComponent<IZebraDetail> = (props) => {
  const { label, value, autoWidth } = props;

  const inlineStyle = { flex: '100%' } as React.CSSProperties;

  const displayValue = () =>
    props.insertHTML ? (
      <div
        className={style.value}
        dangerouslySetInnerHTML={{ __html: String(value) }}
      />
    ) : (
      <div className={style.value}>{value}</div>
    );

  return label ? (
    <div style={autoWidth ? inlineStyle : undefined} className={style.detail}>
      <div className={style.label}>{label.toUpperCase()}</div>
      {displayValue()}
    </div>
  ) : null ;
};

export default ZebraDetail;
